const ROOT = 'RATE_CARD_VIEW_';

const actions = {
  LOAD_CARD_REQUEST: `${ROOT}LOAD_CARD_REQUEST`,
  LOAD_CARD_SUCCESS: `${ROOT}LOAD_CARD_SUCCESS`,
  LOAD_CARD_ERROR: `${ROOT}LOAD_CARD_ERROR`,
  LOAD_CARD_NOT_FOUND: `${ROOT}LOAD_CARD_NOT_FOUND`,

  // Re-reads the card on a timer while an import is still being processed.
  POLL_START: `${ROOT}POLL_START`,
  POLL_STOP: `${ROOT}POLL_STOP`,
  /** The loop ran out of retries or of patience — the page is no longer tracking the import. */
  POLL_ABANDONED: `${ROOT}POLL_ABANDONED`,

  // A one-row probe whose only purpose is `totalCount`: lines exist only after a publish, so it is how
  // the page tells a published card from a validated one.
  LOAD_LINE_COUNT_REQUEST: `${ROOT}LOAD_LINE_COUNT_REQUEST`,
  LOAD_LINE_COUNT_SUCCESS: `${ROOT}LOAD_LINE_COUNT_SUCCESS`,
  LOAD_LINE_COUNT_ERROR: `${ROOT}LOAD_LINE_COUNT_ERROR`,

  LOAD_LINE_HEADERS_REQUEST: `${ROOT}LOAD_LINE_HEADERS_REQUEST`,
  LOAD_LINE_HEADERS_SUCCESS: `${ROOT}LOAD_LINE_HEADERS_SUCCESS`,
  LOAD_LINE_HEADERS_ERROR: `${ROOT}LOAD_LINE_HEADERS_ERROR`,

  LOAD_LINES_REQUEST: `${ROOT}LOAD_LINES_REQUEST`,
  LOAD_LINES_SUCCESS: `${ROOT}LOAD_LINES_SUCCESS`,
  LOAD_LINES_ERROR: `${ROOT}LOAD_LINES_ERROR`,

  EXPORT_LINES_REQUEST: `${ROOT}EXPORT_LINES_REQUEST`,
  EXPORT_LINES_SETTLED: `${ROOT}EXPORT_LINES_SETTLED`,

  // Draft cards only. There is no update endpoint, so this is the only way a card that was created
  // against the wrong version — or with a file nobody wants — leaves the list.
  DELETE_REQUEST: `${ROOT}DELETE_REQUEST`,
  DELETE_SUCCESS: `${ROOT}DELETE_SUCCESS`,
  DELETE_ERROR: `${ROOT}DELETE_ERROR`,

  CLEAR_STORE: `${ROOT}CLEAR_STORE`,
} as const;

export default actions;
